import React from 'react';

import { Spacer, Text } from '@ontruck/orc';
import arrowRenderer from './arrowRenderer';

const Task = ({ changes: { task, owner, previous_owner }, ...props }) => {
  return (
    <Spacer {...props}>
      <Text color="grey800" display="block">
        Task: {task}
      </Text>
      <Text color="grey800" display="block">
        Owner: {arrowRenderer(previous_owner, owner)}
      </Text>
    </Spacer>
  );
};

export default Task;
